import { AUTHENTICATION_KEY } from 'constants/authConstants';
import { AUTH } from '../store/constants';
import initialState from './initialState';
import * as types from '../actions/actionTypes';

const authReducer = (state = initialState[AUTH], action) => {
  if (action.type === types.LOAD_CURRENT_USER_INFO.SUCCESS) {
    return {
      [AUTHENTICATION_KEY]: true
    };
  }
  if (action.type === types.CLEAR_USER_SESSION) {
    return {
      [AUTHENTICATION_KEY]: false
    };
  }
  return state;
};

export default authReducer;
